<script setup>
import { Tabs, Tab, Button, Icon, Breadcrumb, Select, Label, Input } from '@components'

// Settings store.
import { useSettings } from '@store/settings'
const $settings = useSettings()

const updateIntegration = () => {
    window.alert('Update Integration')
}
</script>


<template>
    <div class="md:max-w-[736px] m-auto mt-[-28px] transition" :class="{ 'opacity-60 pointer-events-none': $settings.isSaving }">
        <!-- breadcrumb -->
        <Breadcrumb wrapperClass="mb-[48px]" :items="[
            { icon: true, name: 'settings01', route: { name: 'settings' } },
            { name: 'Integrations', route: { name: 'settings.integrations' }, params: { tab: 'google-calendar' } }
        ]" />

        <!-- form tabs -->
        <Tabs default="google-calendar" design="underline">
            <Tab id="google-calendar">Google Calendar</Tab>

            <!-- google calendar -->
            <template #google-calendar>
                <div class="space-y-6"> 

                    <div class="flex flex-col gap-2 w-72">
                        <Label>Choose Google App</Label>
                        <Select :options="[
                            { label: 'Prebook Default', value: 'default' },
                            { label: 'Custom App', value: 'custom' }
                        ]" v-model="$settings.getSettings.google.app_mode" />
                    </div>

                    <div v-if="$settings.getSettings.google.app_mode === 'custom'" class="space-y-6 w-72">
                        <div class="flex flex-col gap-2">
                            <Label>Client ID</Label>
                            <Input v-model="$settings.getSettings.google.client_id" placeholder="Enter Client ID" required/>
                        </div>

                        <div class="flex flex-col gap-2">
                            <Label>Client Secret</Label>
                            <Input v-model="$settings.getSettings.google.client_secret" placeholder="Enter Client Secret" required/>
                        </div>

                        <div class="flex flex-col gap-2">
                            <Label>Redirect URI</Label>
                            <Input v-model="$settings.getSettings.google.redirect_uri" placeholder="Enter Redirect URI"/>
                        </div>
                    </div>

                </div>
            </template>

        </Tabs>

         <!-- Footer actions -->
         <div class="flex items-center gap-[42px] mt-[52px]">
            <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between"
                @click.prevent="$router.push({ name: 'settings' })">
                <div class="w-[70%]">Back</div>
                <template #before>
                    <Icon name="arrowNarrowLeft" size="20px"></Icon>
                </template>

            </Button>
            <Button @click="updateIntegration()" size="xl" type="primary" radius="square"
                classButton="w-full justify-between">
                <div class="w-[95%]">Update</div>
            </Button>
        </div>
    </div>
</template>
